import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobicred',
  templateUrl: './mobicred.component.html',
  styleUrls: ['./mobicred.component.scss']
})
export class MobicredComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
